<template>
	<div id="app">
		<div class="preloader"></div>
		<router-view></router-view>
	</div>
</template>

<script>
	import weixin_share from "@/assets/js/share.js"
	export default {
        name: "app",
		mounted(){
			$('.preloader').delay(500).fadeOut(500);
			//微信分享
		    // weixin_share({
			// 	postUrl: 'signPackage.php',
			// 	shareData: {
			// 		title: '授权分享测试',
			// 		desc: '授权分享测试描述',
			// 		imgUrl: 'http://nikai.site/share/pic.jpg',
			// 		link: 'http://nikai.site/share/index.html'
			// 	}
			// });
		}
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app.vue